import * as THREE from 'three';
import { CanvasTexture } from 'three';
import {gsap} from 'gsap';

import * as mutationTypes from '../mutation-types';
// import fabrics from '../../fabrics';

const state = () => ({
  fabrics: [],
  selectedFabric: null,
  defaultFabric: null,
  loaders: {
    texture: new THREE.TextureLoader(),
  },
  fragShaderPrepend: 'uniform float alphaIntensity;\n' + 'uniform float repeatX;\n' + 'uniform float repeatY;\n' + 'uniform float tScale;\n' + 'uniform float tRotation;\n' + 'uniform float tOffsetX;\n' + 'uniform float tOffsetY;\n'  + 'uniform sampler2D tSelfMap;\n',
  fragShaderReplace: `
#ifdef USE_COLOR

	diffuseColor.rgb *= vColor;

#endif
#ifdef USE_MAP

  float angle = radians(tRotation);
  float s = sin(angle);
	float c = cos(angle);
	mat2 matrixRotation = mat2(c, -s, s, c);
	
	float scale = 1.0/tScale;
	mat2 matrixScale = mat2(scale*repeatX, 0.0, 0.0, -scale*repeatY);
	
	vec2 translate = vec2(tOffsetX,tOffsetY)*scale;
	
	vec2 uvMap = vUv - vec2(0.5,0.5);
	
	mat2 m = matrixRotation*matrixScale;

  vec4 texelColor;

	vec4 texelMapColor = texture2D( map, (uvMap + translate)*m );
	texelMapColor = mapTexelToLinear( texelMapColor );
	
	vec4 texelSelfMapColor = texture2D( tSelfMap, vUv );
  texelSelfMapColor = mapTexelToLinear( texelSelfMapColor );

	texelColor = mix(texelMapColor,texelSelfMapColor, clamp(texelSelfMapColor.r*1.5, 0.0, 0.9 ));
	diffuseColor = vec4(clamp(texelColor.r,0.10,0.9),clamp(texelColor.g,0.10,0.9),clamp(texelColor.b,0.10,0.9),texelColor.a);

#else

  vec4 texelColor;
  vec4 texelSelfMapColor = texture2D( tSelfMap, vUv );  
  texelColor = mix(diffuseColor,texelSelfMapColor, clamp(texelSelfMapColor.r*1.5, 0.0, 0.9 ) );
  diffuseColor = vec4(clamp(texelColor.r,0.15,0.85),clamp(texelColor.g,0.15,0.85),clamp(texelColor.b,0.15,0.85),texelColor.a);

#endif
`,
  uniforms: {
    repeatX: { value: 1.0 },
    repeatY: { value: 1.0 },
    tScale: { value: 1.0 },
    tRotation: { value: 0.0 },
    tOffsetX: { value: 0.0 },
    tOffsetY: { value: 0.0 },
    tSelfMap: { value: null },
    alphaIntensity: { value: 1.8 },
  }
});

const getters = {
  fabrics: state => state.fabrics,
  fabricById: (state) => (id) => {
    return state.fabrics.filter( el => el.id === id)[0];
  },
  selectedFabric: state => state.selectedFabric,
  defaultFabric: state => state.defaultFabric,
};

const mutations = {
  [mutationTypes.APPLY_FABRIC] (state,material) {
    state.selectedFabric = material;
  },
  [mutationTypes.INIT_FABRICS] (state, fabrics) {
    state.fabrics = fabrics;

    const defaultFabric = fabrics.filter(el => el.name === 'Positano')[0];
    if(defaultFabric) {
      state.defaultFabric = defaultFabric;
    } else {
      state.defaultFabric = fabrics[0];
    }

  },
};

const actions = {
  applyFabric: ({ commit, dispatch, rootGetters }, { payload, mesh }) => {

    if(!mesh)
      mesh = rootGetters['clothes/selectedMesh'];

    // console.log(mesh);

    return new Promise( (resolve,reject) => {

      if(!mesh.id) {
        reject('You need to select a mesh to apply the fabric');
      }

      try {
          dispatch('initFabric',payload)
            .then(( res ) => {

              // console.log(res);
              let order = mesh.name.toUpperCase().includes('OUTSIDE') ? 5 : 0; //todo definire una logica per ordinare le mesh
              // console.log(order,mesh.name);
              //correzioni bomber
              // console.log(mesh.name); //todo definire una logica per ordinare le mesh
              if(mesh.name.toUpperCase().includes('BOMBER_LINING')) {
                order = 3;
              } else if( mesh.name.toUpperCase() === 'BOMBER-BOMBER') {
                // console.log('BOMBER-BOMBER')
                order = 5;
              }

              if(res.backSideMaterial) {

                if(!mesh.userData.backMesh) {
                  //se ho già creato la backMesh allora gli assegno il nuovo materiale
                  // dispatch('disposeMaterial',mesh.userData.backMesh.material);
                  // mesh.userData.backMesh.material = res.backSideMaterial;
                // } else {
                  //altrimenti inizializzo la backMesh
                  let backMesh = mesh.userData.backMesh = mesh.clone();
                  // backMesh.material = res.backSideMaterial;

                  if(res.backSideMaterial.transparent) {
                    backMesh.renderOrder = 1 + order;
                  } else {
                    backMesh.renderOrder = -1;
                  }

                  // fix problem if mesh rotation is not equal to zero
                  backMesh.setRotationFromEuler(new THREE.Euler(0));
                  mesh.add(backMesh);
                }

                //correzione render per la parte interna al bomber - NB. la mesh frontale è quella interna, metre quella back è quella esterna
                // if(mesh.name.toUpperCase().includes('BOMBER_LINING')) {
                //   mesh.userData.backMesh.renderOrder = 2 + order;
                // }

                dispatch('disposeMaterial',mesh.userData.backMesh.material);
                mesh.userData.backMesh.material = res.backSideMaterial;

              } else if(mesh.userData.backMesh) {

                //controllo se nella mesh avevo inserito la back mesh precedente, nel caso la rimuovo
                mesh.remove(mesh.userData.backMesh);
                dispatch('clothes/disposeMesh',mesh.userData.backMesh,{root:true});
                
                mesh.userData.backMesh = null; // this fix bug after setting opaque material

              }

              if(res.frontSideMaterial.transparent) {
                mesh.renderOrder = 2 + order;
                // if(mesh.name.toUpperCase().includes('BOMBER_LINING')) {
                //   mesh.renderOrder = 1 + order;
                // }
              } else {
                mesh.renderOrder = -1;

              }

              //copio gli uniforms
              let { uniforms } = mesh.material.userData;
              //correzione render per la parte interna al bomber - NB. la mesh frontale è quella interna, metre quella back è quella esterna

              mesh.material = res.frontSideMaterial;
              mesh.userData.fabric = payload;

              // console.log(mesh);

              
              if(uniforms) {

                dispatch('setUniforms',{from: uniforms, to: mesh.material.userData.uniforms});

                let { backMesh } = mesh.userData;

                if(backMesh) {
                  dispatch('setUniforms',{from: uniforms, to: backMesh.material.userData.uniforms});
                }

              }


              commit(mutationTypes.APPLY_FABRIC,payload);

              //setto la texture selezionata
              if(rootGetters['textures/selectedTexture']) {
                dispatch('textures/setSelectedTexture',rootGetters['textures/selectedTexture'],{root: true}).then(() => {
                  dispatch('render',null,{root:true});
                  resolve(payload);
                });
              } else if(rootGetters['textures/selectedColor']) {
                // dispatch('clothes/setMeshColor',rootGetters['textures/selectedColor'],{root:true}).then(() => {
                let color = new THREE.Color(rootGetters['textures/selectedColor']);
                  commit('clothes/'+mutationTypes.SET_MESH_COLOR,color,{root:true});
                  dispatch('render',null,{root:true});
                  resolve(payload);
                // });

              } else {
                dispatch('render',null,{root:true});
                resolve(payload);
              }

              dispatch('applyMorph',{mesh,payload});


          })

        // }

      } catch (e) {
        reject(`An error happened: ${e}`);
      }
    })
  },
  setUniforms: (_,{from,to}) => {

    to.repeatX.value = from.repeatX.value;
    to.repeatY.value = from.repeatY.value;
    to.tScale.value = from.tScale.value;
    to.tRotation.value = from.tRotation.value;
    to.tOffsetX.value = from.tOffsetX.value;
    to.tOffsetY.value = from.tOffsetY.value;

  },
  applyMorph: ({dispatch},{mesh, payload}) => {

    // console.log(mesh);

    const { morphTargetDictionary } = mesh;

    // console.log(mesh,payload,morphTargetDictionary);

    if(morphTargetDictionary) {
      let i = morphTargetDictionary[payload.name];

      if(i === undefined) return;

      const target = {
        value: 0,
      }

      const { backMesh } = mesh.userData;
      if(backMesh) {
          backMesh.material.setValues({morphTargets: true, morphNormals: true });
          backMesh.morphTargetInfluences = mesh.morphTargetInfluences;
      }

      // }

      let resetIndex = null;
      mesh.morphTargetInfluences.filter((el,i) => {
        el > 0 ? resetIndex = i : null;
      });

      // console.log(i,payload.name,mesh);

      mesh.material.setValues({morphTargets: true, morphNormals: true });
      
      // mesh.morphTargetInfluences[0] = value;
      // console.log(mesh.material);

      gsap.to(target,{duration: 0.8, value: 1, ease: "power3.out",onUpdate: () => {
        mesh.morphTargetInfluences[resetIndex] = 1 - target.value;
        mesh.morphTargetInfluences[i] = target.value;
        mesh.material.needsUpdate = true;
        backMesh ? backMesh.material.needsUpdate = true : null;
        dispatch('render',null,{root:true});
      }, onComplete: () => {

        // todo regenerate back mesh after morph to resolve glitter problem???
        // dispatch('refreshBackMash',mesh);
        // mesh.geometry.computeVertexNormals();
        
      }});
      
      // ISSUE:
      // 1) mesh presents glitter surface afer morphing, ( the problem is not caused by backmesh )
      // 2) shadow are not updating after morphing and 
      
      
    }

  },
  // refreshBackMash: ({dispatch},payload) => {

  //   console.log('refresh back mesh');

  //   const backMaterial = payload.userData.backMesh.material.clone();

  //   payload.remove(payload.userData.backMesh);
  //   dispatch('clothes/disposeMesh',payload.userData.backMesh,{root:true});

  //   let backMesh = payload.userData.backMesh = payload.clone();

  //   backMesh.material = backMaterial;
  //   // payload.add(backMesh);

  //   dispatch('render',null,{root:true});
    
  //   // payload.userData.backMesh = null; // this fix bug after setting opaque material

  // },
  initFabric: async ({ dispatch, state },{ material }) => {

    let frontSideMaterial = new THREE.MeshPhysicalMaterial({
      transparent: true,
      bumpScale: material.bumpMap.scale,
      side: THREE.FrontSide,
      roughness: material.roughnessMap.scale,
      transmission: material.transmission,
      opacity: 1,
    })

    frontSideMaterial.needsUpdate = true;

    frontSideMaterial.color = new THREE.Color(1.0,1.0,1.0);
    // let repeat = { x:1, y:1 };

    //creo lo userData con i valori comuni da assegnare ad entrambi
    let userData = {
      material: material,
      uniforms: JSON.parse( JSON.stringify( state.uniforms ) ),
    }

    if( material.transparent && material.alphaMap.intensity) {
      userData.uniforms.alphaIntensity.value = material.alphaMap.intensity;
    }

    frontSideMaterial.onBeforeCompile = (shader) => {

      shader.uniforms = Object.assign( shader.uniforms, userData.uniforms );

      shader.fragmentShader = state.fragShaderPrepend + shader.fragmentShader;

      //rimpiazzo il map fragment con quello personalizzato e ci prependo il color fragment
      shader.fragmentShader =
        shader.fragmentShader.replace('#include <map_fragment>', state.fragShaderReplace );

      //rimuovo il color fragment perchè lo inserisco prima del map fragment
      shader.fragmentShader =
        shader.fragmentShader.replace('#include <color_fragment>', `` );

      //rimpiazzo l'alphamap fragment con uno personalizzato in cui vado a modificare il calcolo della traspareza
      //in questo modo per la trasparenza uso la stessa mappa del bump
      shader.fragmentShader = shader.fragmentShader.replace('#include <alphamap_fragment>', `

#ifdef USE_ALPHAMAP

	diffuseColor.a *= clamp(texture2D( alphaMap, vUv ).g*alphaIntensity,0.0,1.0);

#endif

` );

    }

    // if(material.transparent) {
    //   frontSideMaterial.depthWrite = false;
    //   frontSideMaterial.premultipliedAlpha = true;
    // }

    //clono il materiale per il backSide
    let backSideMaterial = null;
    if(material.transparent) {
      backSideMaterial = frontSideMaterial.clone();
      backSideMaterial.side = THREE.BackSide;
      // backSideMaterial.depthWrite = false; //
      backSideMaterial.onBeforeCompile = frontSideMaterial.onBeforeCompile;
    }

    //JSON.parse( JSON.stringify( source.userData ) )

    //salvo le reference all'interno dei due materiali
    backSideMaterial ? backSideMaterial.userData = userData : null;
    frontSideMaterial.userData = userData;

    //carico la map
    if( material.map && material.map.src) {
      // material.map.repeat = repeat;

      await dispatch('textures/uploadTexture',material.map, {root: true});

      userData.uniforms.tSelfMap = { type: "t", value: material.map.inst };
      // backSideMaterial ? backSideMaterial.map = material.map.inst : null;
      // frontSideMaterial.map = material.map.inst;

    }

    //carico il bump
    if( material.bumpMap && material.bumpMap.src ) {
      // material.bumpMap.repeat = repeat;

      await dispatch('textures/uploadTexture',material.bumpMap, {root: true});

      backSideMaterial ? backSideMaterial.bumpMap = material.bumpMap.inst : null;
      frontSideMaterial.bumpMap = material.bumpMap.inst;
    }

    //carico l'alpha

    if( material.transparent && material.alphaMap && material.alphaMap.src) {
      // material.alphaMap.repeat = repeat;

      await dispatch('textures/uploadTexture',material.alphaMap, {root: true});

      backSideMaterial ? backSideMaterial.alphaMap = material.alphaMap.inst : null;
      frontSideMaterial.alphaMap = material.alphaMap.inst;
    } else if( material.transparent ) {
      //altrimenti uso il bump per la trasparenza
      backSideMaterial ? backSideMaterial.alphaMap = material.bumpMap.inst : null;
      frontSideMaterial.alphaMap = material.bumpMap.inst;

    }



    //carico il roughness
    if( material.roughnessMap && material.roughnessMap.src) {
      // material.roughnessMap.repeat = repeat;

      await dispatch('textures/uploadTexture',material.roughnessMap, {root: true});

      backSideMaterial ? backSideMaterial.roughnessMap = material.roughnessMap.inst : null;
      frontSideMaterial.roughnessMap = material.roughnessMap.inst;
    } else {
      //altrimenti uso il bump per la trasparenza
      backSideMaterial ? backSideMaterial.roughness =  material.roughnessMap.scale : null;
      frontSideMaterial.roughness =  material.roughnessMap.scale;
    }

    if(!backSideMaterial) {
      frontSideMaterial.side = THREE.DoubleSide;
    }

    return {
      frontSideMaterial,
      backSideMaterial
    };

  },
  initFabrics: ({ commit }, payload) => {
    commit(mutationTypes.INIT_FABRICS,payload);
  },
  disposeMaterial: ({ dispatch },payload) => {
    // console.log('dispose material');
    //receive the material and call the dispose method than foreach texture dispatch the disposeTexture action

    if(payload.bumpMap) {
      dispatch('textures/disposeTexture',payload.bumpMap,{root: true});
    }

    if(payload.alphaMap) {
      dispatch('textures/disposeTexture',payload.alphaMap,{root: true});
    }

    if(payload.roughnessMap) {
      dispatch('textures/disposeTexture',payload.roughnessMap,{root: true});
    }

    if(payload.normalMap) {
      dispatch('textures/disposeTexture',payload.normalMap,{root: true});
    }

    if(payload.map && payload.map instanceof CanvasTexture) {
      // console.log(payload.map);
      dispatch('textures/disposeTexture',payload.map,{root: true});
    }

    payload.dispose();
    // console.log('material dispoase: ',payload);
    payload = null;

  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}




